import { css } from 'styled-components'

export default css`
  width: 8.2rem;
`
